import { render } from "./corporateCulture.vue?vue&type=template&id=6a675c9a"
import script from "./corporateCulture.vue?vue&type=script&lang=js"
export * from "./corporateCulture.vue?vue&type=script&lang=js"

import "./corporateCulture.vue?vue&type=style&index=0&id=6a675c9a&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__